<template>
  <line-chart :load="loadChartData" />
</template>

<script>
import LineChart from "@/components/LineChart";

export default {
  name: "StatTopics",
  components: { LineChart },
  methods: {
    async loadChartData(filters) {
      return await this.axios.form("base:/api/admin/stat/topics", filters);
    },
  },
};
</script>

<style lang="scss" scoped></style>
